import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

const EXPERTX_AVATAR =
  'https://x.growthspace.com/assets/login-avatar-1-CrjMLX59.png';

function LoginArtPanel() {
  return (
    <div className="relative hidden items-center justify-center overflow-hidden bg-white lg:flex lg:w-1/2">
      <div
        className="absolute h-[1220px] w-[1220px] shrink-0 rounded-full bg-expertx-purple"
        style={{ left: 'calc(-53% - 100px)', top: 'calc(-70% + 50px)' }}
        aria-hidden
      />
      <div className="absolute right-[130px] z-10 h-[500px] w-[500px]">
        <img
          src={EXPERTX_AVATAR}
          alt=""
          className="h-full w-full object-contain"
          aria-hidden
        />
      </div>
    </div>
  );
}

export function LoginPage() {
  const { user, signIn, loading } = useAuth();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? '/';

  useEffect(() => {
    document.title = 'Sign in · Deal Analyzer';
  }, []);

  if (loading) {
    return null;
  }

  if (user) {
    return <Navigate to={from} replace />;
  }

  return (
    <div className="relative flex min-h-screen">
      <LoginArtPanel />

      <div className="flex min-h-screen w-full items-center justify-center bg-white p-8 lg:w-1/2">
        <div className="relative z-20 flex w-full max-w-md flex-col items-center rounded-3xl border border-expertx-border bg-white/70 px-10 py-14 backdrop-blur-lg sm:px-16 sm:py-16">
          <h1 className="text-center font-serif text-2xl font-bold text-expertx-purple">
            Welcome to Deal Analyzer
          </h1>
          <p className="mt-3 text-center font-ibm text-sm font-normal text-slate-950">
            Sign in to access your deal intelligence
          </p>

          <button
            type="button"
            onClick={signIn}
            className="mt-10 flex h-11 w-full items-center justify-center gap-2 rounded-xl bg-expertx-purple font-ibm text-base font-medium text-expertx-accent transition hover:bg-[#3a0245] focus:outline-none focus:ring-2 focus:ring-expertx-border focus:ring-offset-2"
          >
            Sign in with Google
          </button>
        </div>
      </div>
    </div>
  );
}
